import { ref, computed, watch } from "@vue/composition-api";
// import { title } from '@core/utils/filter'
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import ability from "@/libs/acl/ability";
import { debounce } from "lodash";
import useFilterCounter from "@/components/Filters/useFiltersCount";

export default function useList() {
  const refListTable = ref(null);

  const toast = useToast();

  const tableColumns = [
    { label: "billing_price.region", key: "region", sortable: true },
    { label: "billing_price.security_company", key: "security_company", sortable: true },
    { label: "billing_price.description", key: "description", sortable: true },
    { label: "billing_price.profile", key: "profile", sortable: true },
    { label: "billing_price.hours", key: "hours", sortable: true },
    { label: "billing_price.days", key: "days", sortable: true },
    { label: "billing_price.cost_per_hour", key: "cost_per_hour", sortable: true },
    { label: "billing_price.cost_per_shift", key: "cost_per_shift", sortable: true },
    {
      label: "date.created_at",
      key: "created_at",
      sortable: true,
      formatter: "formatDateAssigned",
    },
    {
      label: "date.updated_at",
      key: "updated_at",
      sortable: true,
      formatter: "formatDateAssigned",
    },
  ];

  const action = ref("list");

  /* if (ability.can('update', 'BillingPrice') == true || ability.can('delete', 'BillingPrice') == true) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  } */

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    store
      .dispatch("billing_price/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        action: action.value,
      })
      .then((response) => {
        if (action.value == "export") {
          action.value = "list";
        } else {
          callback(response.data);
          totalList.value = response.meta.total;
        }
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

    const formatCurrency = amount => {
      const formattedCurrency = new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
  }).format(amount);
  
      return formattedCurrency;
    }

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([currentPage, perPage], () => {
    refetchData();
  });

  watch(
    [searchQuery],
    debounce(() => {
      refetchData();
    }, 500)
  );

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    refetchData();
  };
  const clearSearchFilters = () => {
    buildFilters();
  };

  return {
    action,
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    refetchData,
    formatCurrency,
    filtersCount,
    buildFilters,
    clearSearchFilters,
  };
}

